import { useAtomValue, useSetAtom } from "jotai";

import {
  isLoadingAtom,
  selectedCoursesAtom,
  courseAtom,
  isCourseCreatorAtom,
  isCourseMemberAtom,
  newCourseAtom,
  joinCourseDialogOpenAtom,
  handleClickCourseAtom,
} from "../atoms/courseAtoms";

export default function useCourse() {
  const isLoading = useAtomValue(isLoadingAtom);
  const setIsLoading = useSetAtom(isLoadingAtom);
  const selectedCourses = useAtomValue(selectedCoursesAtom);
  const setSelectedCourses = useSetAtom(selectedCoursesAtom);
  const course = useAtomValue(courseAtom);
  const isCourseCreator = useAtomValue(isCourseCreatorAtom);
  const isCourseMember = useAtomValue(isCourseMemberAtom);
  const newCourse = useAtomValue(newCourseAtom);
  const setNewCourse = useSetAtom(newCourseAtom);
  const joinCourseDialogOpen = useAtomValue(joinCourseDialogOpenAtom);
  const setIsJoinCourseDialogOpen = useSetAtom(joinCourseDialogOpenAtom);
  const handleClickCourse = useSetAtom(handleClickCourseAtom);

  return {
    isLoading,
    setIsLoading,
    selectedCourses,
    setSelectedCourses,
    course,
    isCourseCreator,
    isCourseMember,
    newCourse,
    setNewCourse,
    joinCourseDialogOpen,
    setIsJoinCourseDialogOpen,
    handleClickCourse,
  };
}
